import React, { useState, useEffect } from 'react'
import axios from "axios";
import "./Products.css";
import EditProduct from './EditProduct';
import AddProduct from './AddProduct';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import AdminNav from '../AdminNav';
import { decodeToken } from "react-jwt";
import NotFoundPage from '../NotFoundPage';





function Products() {
    const { REACT_APP_API_URL } = process.env;

    const token = localStorage.getItem("access_token");
    const decodedToken = decodeToken(token);
    const [products, setProducts] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState({});
    const [currentPage, setCurrentPage] = useState("");
    const [open, setOpen] = React.useState(false);
    const [deleteId, setDeleteId] = useState();
    const [searchTerm, setSearchTerm] = useState("");
    const handleOpen = (id) => {
        setOpen(true);
        setDeleteId(id);
    }
    const handleClose = () => setOpen(false);

    const getAllProducts = async () => {
        let result = await axios.get(`${REACT_APP_API_URL}/get-products/`);
        setProducts(result.data);
    }

    const deleteProduct = async () => {
        try {
            await axios.post(
                `${REACT_APP_API_URL}/delete-product/${deleteId}`,
                {
                    //body
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: "Bearer " + token
                    }
                }
            ).then(() => {
                handleClose();
                getAllProducts();
            });
        } catch (error) { }
    }

    useEffect(() => {
        getAllProducts();
    }, [])

    const switchPage = (page) => {
        setCurrentPage(page);
    };

    if (currentPage === "editproduct") {
        return (<EditProduct productDetail={selectedProduct} />)
    }

    if (currentPage === "addproduct") {
        return (<AddProduct />)
    }

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: '#331d42',
        border: '1px solid #e4c92e46',
        boxShadow: 24,
        p: 4,

    };

    if (decodedToken?.role === 1) {
        return (
            <div className="container product-section">
                <div className="shop-section">
                    <AdminNav />
                    <Modal
                        open={open}
                        onClose={handleClose}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                    >
                        <Box sx={style}>
                            <center><h1 style={{ fontSize: '24px', marginBottom: '25px' }}>Are you sure?</h1>
                                <button onClick={() => deleteProduct()} style={{ margin: '10px' }} className='back-btn'>Yes</button>
                                <button onClick={() => handleClose()} style={{ margin: '10px' }} className='back-btn'>No</button>
                            </center>
                        </Box>
                    </Modal>
                    <button onClick={() => switchPage("addproduct")} className='login-btn'>+ Add new product</button>
                    <input onChange={(e) => { setSearchTerm(e.target.value) }} type="text" placeholder='Search item...' style={{ marginTop: '25px', padding: '10px 20px', borderRadius: '10px', border: 'none' }} />
                    <table style={{ marginTop: '50px' }}>
                        <tbody>
                            <tr><td>Sku (item-id)</td><td>Thumbnail</td><td>Name</td><td>Price</td></tr>
                            {
                                products.filter((item) => {
                                    return searchTerm.toLowerCase() === '' ? item : item.item_name.toLowerCase().includes(searchTerm.toLowerCase());
                                }).map(product => {
                                    return (
                                        <tr key={product.id}>
                                            <td>{product.sku}</td>
                                            <td><img style={{ width: '32px' }} src={product.item_image} alt={product.item_name} /></td>
                                            <td>{product.item_name}</td>
                                            <td>${product.discount_price > 0 ? (<><s>{product.item_price}</s> <span style={{ color: 'green' }}>${product.discount_price}</span></>) : (product.item_price)}</td>
                                            <td style={{ cursor: 'pointer' }} onClick={() => { switchPage("editproduct"); setSelectedProduct(product) }}>Edit</td>
                                            <td style={{ cursor: 'pointer' }} onClick={() => handleOpen(product.id)}>Delete</td>
                                        </tr>
                                    )
                                })}
                        </tbody>
                    </table>
                </div>
            </div>
        )
    } else {
        return (<NotFoundPage />)
    }
}

export default Products